import { NgModule } from "@angular/core";
import { provideHttpClient, withInterceptors } from "@angular/common/http";
import { environment } from "../environments/environment";
import { provideCalAngular } from "@cvx/cal-angular";
import { tokenInterceptor } from "./authentication/token-interceptor";

@NgModule({
  declarations: [],
  exports: [],
  providers: [
    provideHttpClient(withInterceptors([tokenInterceptor])),
    provideCalAngular(
      {
        autoSignIn: true,
        popupForLogin: false,
        cacheLocation: "localStorage",
        instance: "https://login.microsoftonline.com/",
        tenantId: "fd799da1-bfc1-4234-a91c-72b3a1cb9e26",
        clientId: environment.clientId,
        redirectUri: "/auth",
        oidcScopes: ["openid", "profile", "User.Read", "offline_access"],
        graphScopes: ["User.Read", "User.Read.All", "Group.Read.All"],
      }
    ),

  ],
})
export class AppModule { }
